import Loading from "@/components/Loading";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { cn } from "@/lib/utils";
import { useCommonProblems } from "@/stores/appStore";

import { useEffect } from "react";
import Markdown from "react-markdown";

type HelpAccordionProps = {
  tagKey: string;
}

export function HelpAccordion({
  tagKey = 'pricing',
}: HelpAccordionProps) {
  const {
    value: commonProblems,
    fetch: fetchCommonProblems,
  } = useCommonProblems().commonProblems;

  useEffect(() => {
    fetchCommonProblems();
  }, [fetchCommonProblems]);

  return (
    <div className="flex flex-col items-center justify-center mt-16 pb-10">
      <h2 className="font-semibold text-4xl">常见问题</h2>
      <Accordion type="single" collapsible className="w-full space-y-5 mt-8">
        {
          commonProblems ? (
            commonProblems.filter(({ tag = [] }) => {
              return !tag.length || tag.includes(tagKey);
            }).map(({ title, content }, index) => {
              return (
                <AccordionItem
                  key={title + index}
                  value={`item-${index}`}
                  className="border border-border rounded-xl pl-7 pr-8"
                >
                  <AccordionTrigger className="text-2xl hover:no-underline py-6">
                    {title}
                  </AccordionTrigger>
                  <AccordionContent className={cn(
                    "text-base text-muted-foreground",
                    "transition-all	duration-500",
                  )}>
                    <Markdown>{content}</Markdown>
                  </AccordionContent>
                </AccordionItem>
              )
            })
          ) : <Loading />
        }
      </Accordion>
    </div>
  )
}